module.exports = __webpack_public_path__ + "static/media/zeposia_header.0dda3a7a.svg";